import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import { useUser } from '~/composables/_next/useUser';
import { useWishlistSidebarIntent } from '~/composables/useWishlistSidebarIntent';
export default /*#__PURE__*/_defineComponent({
  __name: 'RecipesWishlistButtonGraphQL',
  props: {
    recipeId: {
      type: String,
      required: true
    },
    recipeTitle: {
      type: String,
      required: true
    },
    recipeImage: {
      type: String,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useWishlistSidebarIn = useWishlistSidebarIntent(),
      wishlistIntent = _useWishlistSidebarIn.wishlistIntent,
      clearWishlistIntent = _useWishlistSidebarIn.clearWishlistIntent,
      setWishlistIntent = _useWishlistSidebarIn.setWishlistIntent;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    var route = useRoute();
    var isFavorite = computed(function () {
      return isInRecipesWishlists(props.recipeId);
    });
    function toggleRecipeFromWishlists() {
      if (isAuthenticated.value) {
        isFavorite.value ? removeRecipeFromWishlist(props.recipeId) : toggleSidebar();
      } else {
        doActionOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path,
          action: function action() {
            isInRecipesWishlists(props.recipeId) ? removeRecipeFromWishlist(props.recipeId) : setWishlistIntent(props.recipeId);
          }
        });
      }
    }
    function toggleSidebar() {
      toggleAddRecipeToWishlistSidebar({
        contentfulId: props.recipeId,
        image: props.recipeImage,
        name: props.recipeTitle
      });
    }
    onMounted(function () {
      if (!wishlistIntent.value.recipeId) return;
      if (wishlistIntent.value.recipeId === props.recipeId) {
        toggleSidebar();
        clearWishlistIntent();
      }
    });
    return {
      __sfc: true,
      props: props,
      wishlistIntent: wishlistIntent,
      clearWishlistIntent: clearWishlistIntent,
      setWishlistIntent: setWishlistIntent,
      isAuthenticated: isAuthenticated,
      doActionOrLogin: doActionOrLogin,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      route: route,
      isFavorite: isFavorite,
      toggleRecipeFromWishlists: toggleRecipeFromWishlists,
      toggleSidebar: toggleSidebar,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});